export default __webpack_public_path__ + "static/media/catColoringSample.faf258e32908854da37dd30d7a881d04.png";